var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__background",on:{"click":function($event){return _vm.$emit('cancel')}}}),_c('new-submission',{staticClass:"modal__content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }